import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";

const MaccGames = () => {
  const [isSidebar, setSidebar] = useState(false);
  const PopularGames = [
    // {
    //   src: "/Ezugi/348249.jpg",
    //   name: "7 Lucky",
    //   provider: "vking",
    //   tableCode: "ez_lky7",
    //   tpGameId:601,
    //   endpoint:"ezugi-games",
    // },
    {
    
      name: "Dragon Tiger",
      src: "https://cdn.cloudd.site/vking/lobby/20251135235139.webp",
      tableCode: "imlive80001",
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Bacarrat",
      src: "https://cdn.cloudd.site/vking/lobby/20250635061997.webp",
      tableCode: "imlive80002",
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Sic Bo",
      src: "https://cdn.cloudd.site/vking/lobby/20250635423497.webp",
      tableCode: "imlive80003",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Roulette",
      src: "https://cdn.cloudd.site/vking/lobby/20250656414182.webp",
      tableCode: "imlive80004",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Poker 20-20",
      src: "https://cdn.cloudd.site/vking/lobby/20250657202095.webp",
      tableCode: "imlive80005",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Lucky7",
      src: "https://cdn.cloudd.site/vking/lobby/20250657546627.webp",
      tableCode: "imlive80006",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Andar Bahar",
      src: "https://cdn.cloudd.site/vking/lobby/20250658241527.webp",
      tableCode: "imlive80007",
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Teenpatti One Day",
      src: "https://cdn.cloudd.site/vking/lobby/20250659187425.webp",
      tableCode: "imlive80008",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "32 Cards",
      src: "https://cdn.cloudd.site/vking/lobby/20250659568344.webp",
      tableCode: "imlive80009",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "DTL",
      src: "https://cdn.cloudd.site/vking/lobby/20250244544638.webp",
      tableCode: "imlive80010",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Amar Akbar Anthony",
      src: "https://cdn.cloudd.site/vking/lobby/20250700475591.webp",
      tableCode: "imlive80011",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "3 Cards Judgement",
      src: "https://cdn.cloudd.site/vking/lobby/20250702143222.webp",
      tableCode: "imlive80012",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Queen Race",
      src: "https://cdn.cloudd.site/vking/lobby/20250702277982.webp",
      tableCode: "imlive80013",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Race 20",
      src: "https://cdn.cloudd.site/vking/lobby/20250702395828.webp",
      tableCode: "imlive80014",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Casino War",
      src: "https://cdn.cloudd.site/vking/lobby/20250702494203.webp",
      tableCode: "imlive80015",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Worli Matka",
      src: "https://cdn.cloudd.site/vking/lobby/20250703007881.webp",
      tableCode: "imlive80016",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Lottery",
      src: "https://cdn.cloudd.site/vking/lobby/20250703144187.webp",
      tableCode: "imlive80017",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Test Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250703287938.webp",
      tableCode: "imlive80018",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "The Trap",
      src: "",
      tableCode: "imlive80020",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Trio",
      src: "https://cdn.cloudd.site/vking/lobby/20250704041026.webp",
      tableCode: "imlive80020",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "29 Baccarat",
      src: "https://cdn.cloudd.site/vking/lobby/20250704155191.webp",
      tableCode: "imlive80021",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Two Card Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250704245167.webp",
      tableCode: "imlive80022",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Muflis Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250704362410.webp",
      tableCode: "imlive80023",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Bollywood Casino B",
      src: "https://cdn.cloudd.site/vking/lobby/20250705329608.webp",
      tableCode: "imlive80024",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Poker 1-Day",
      src: "https://cdn.cloudd.site/vking/lobby/20250705436493.webp",
      tableCode: "imlive80025",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "20-20 Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250706083693.webp",
      tableCode: "imlive80026",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Super Over",
      src: "https://cdn.cloudd.site/vking/lobby/20250706198697.webp",
      tableCode: "imlive80027",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "5 Five Cricket",
      src: "https://cdn.cloudd.site/vking/lobby/20250706362959.webp",
      tableCode: "imlive80028",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "1 Day Dragon Tiger",
      src: "https://cdn.cloudd.site/vking/lobby/20250706527314.webp",
      tableCode: "imlive80029",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Dus Ka Dum",
      src: "https://cdn.cloudd.site/vking/lobby/20250707063860.webp",
      tableCode: "imlive80030",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "One Card 20 20",
      src: "https://cdn.cloudd.site/vking/lobby/20250707158923.webp",
      tableCode: "imlive80031",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "One Card Meter",
      src: "",
      tableCode: "imlive80032",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "One Card One Day",
      src: "https://cdn.cloudd.site/vking/lobby/20250707511872.webp",
      tableCode: "imlive80033",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "6 Player Poker",
      src: "https://cdn.cloudd.site/vking/lobby/20250708016645.webp",
      tableCode: "imlive80034",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Instant 2 Cards Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250708595794.webp",
      tableCode: "imlive80035",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Race to 17",
      src: "https://cdn.cloudd.site/vking/lobby/20250709133497.webp",
      tableCode: "imlive80036",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Note Number",
      src: "https://cdn.cloudd.site/vking/lobby/20250709232784.webp",
      tableCode: "imlive80037",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Cricket Match 20-20",
      src: "https://cdn.cloudd.site/vking/lobby/20250710105990.webp",
      tableCode: "imlive80038",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Race to 2nd",
      src: "https://cdn.cloudd.site/vking/lobby/20250710325005.webp",
      tableCode: "imlive80039",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Open Teen patti",
      src: "https://cdn.cloudd.site/vking/lobby/20250710442808.webp",
      tableCode: "imlive80040",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Center Card One Day",
      src: "https://cdn.cloudd.site/vking/lobby/20250711309014.webp",
      tableCode: "imlive80041",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "High Low",
      src: "https://cdn.cloudd.site/vking/lobby/20250711586510.webp",
      tableCode: "imlive80042",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Baccarat One Day",
      src: "https://cdn.cloudd.site/vking/lobby/20250712114647.webp",
      tableCode: "imlive80043",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "10 - 10 cricket",
      src: "https://cdn.cloudd.site/vking/lobby/20250712235336.webp",
      tableCode: "imlive80044",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Muflis Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250712432543.webp",
      tableCode: "imlive80045",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Instant worli",
      src: "https://cdn.cloudd.site/vking/lobby/20250712557078.webp",
      tableCode: "imlive80046",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Super Over",
      src: "https://cdn.cloudd.site/vking/lobby/20250713086188.webp",
      tableCode: "imlive80047",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Center card",
      src: "https://cdn.cloudd.site/vking/lobby/20250713193056.webp",
      tableCode: "imlive80048",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Side Bet city",
      src: "https://cdn.cloudd.site/vking/lobby/20250713312051.webp",
      tableCode: "imlive80049",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "20 20 Teenpatti 2",
      src: "https://cdn.cloudd.site/vking/lobby/20250713532787.webp",
      tableCode: "imlive80050",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Dragon Tiger 2",
      src: "https://cdn.cloudd.site/vking/lobby/20250714072315.webp",
      tableCode: "imlive80051",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Lucky 7",
      src: "",
      tableCode: "imlive80052",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Trio",
      src: "https://cdn.cloudd.site/vking/lobby/20250715506322.webp",
      tableCode: "imlive80053",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR 20-20 DTL",
      src: "https://cdn.cloudd.site/vking/lobby/20250716104152.webp",
      tableCode: "imlive80054",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Mulfis Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250716371916.webp",
      tableCode: "imlive80055",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Bollywood Casino",
      src: "https://cdn.cloudd.site/vking/lobby/20250717096600.webp",
      tableCode: "imlive80056",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Amar Akbar Anthony",
      src: "https://cdn.cloudd.site/vking/lobby/20250717193302.webp",
      tableCode: "imlive80057",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Dragon Tiger",
      src: "https://cdn.cloudd.site/vking/lobby/20250717301164.webp",
      tableCode: "imlive80058",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Casino Meter",
      src: "https://cdn.cloudd.site/vking/lobby/20250717395476.webp",
      tableCode: "imlive80059",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR 20-20 Teenpatti",
      src: "https://cdn.cloudd.site/vking/lobby/20250718061184.webp",
      tableCode: "imlive80060",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR 32 Cards",
      src: "https://cdn.cloudd.site/vking/lobby/20250718188812.webp",
      tableCode: "imlive80061",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Andar Bahar",
      src: "https://cdn.cloudd.site/vking/lobby/20250718336733.webp",
      tableCode: "imlive80062",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR 2 Card TP",
      src: "https://cdn.cloudd.site/vking/lobby/20250718508214.webp",
      tableCode: "imlive80063",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Queen Race",
      src: "https://cdn.cloudd.site/vking/lobby/20250719099198.webp",
      tableCode: "imlive80064",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Poker",
      src: "https://cdn.cloudd.site/vking/lobby/20250719195576.webp",
      tableCode: "imlive80065",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Race T20",
      src: "https://cdn.cloudd.site/vking/lobby/20250720276549.webp",
      tableCode: "imlive80066",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Auto Roulette",
      src: "https://cdn.cloudd.site/vking/lobby/20250720409166.webp",
      tableCode: "imlive80067",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR High low",
      src: "https://cdn.cloudd.site/vking/lobby/20250720593567.webp",
      tableCode: "imlive80068",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR Worli Matka",
      src: "https://cdn.cloudd.site/vking/lobby/20250721115272.webp",
      tableCode: "imlive80069",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "VR 29 card bacarrat",
      src: "https://cdn.cloudd.site/vking/lobby/20250721335241.webp",
      tableCode: "imlive80070",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Lankesh",
      src: "https://cdn.cloudd.site/vking/lobby/20250721463468.jpeg",
      tableCode: "imlive80071",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Aviator X",
      src: "",
      tableCode: "imlive80072",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "AviatorX2",
      src: "",
      tableCode: "imlive80073",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "High Card VR",
      src: "https://cdn.cloudd.site/vking/lobby/20250722168963.webp",
      tableCode: "imlive80074",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Center Card VR",
      src: "https://cdn.cloudd.site/vking/lobby/20250722305712.webp",
      tableCode: "imlive80075",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Kaun Banega Crorepati VR",
      src: "https://cdn.cloudd.site/vking/lobby/20250722547454.webp",
      tableCode: "imlive80076",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "AK47 VR",
      src: "https://cdn.cloudd.site/vking/lobby/20250723069813.webp",
      tableCode: "imlive80077",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Crash X",
      src: "",
      tableCode: "imlive80078",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Limbo",
      src: "",
      tableCode: "imlive80079",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Dice",
      src: "",
      tableCode: "imlive80080",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Mines",
      src: "",
      tableCode: "imlive80081",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Diamonds",
      src: "",
      tableCode: "imlive80082",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Plinko",
      src: "",
      tableCode: "imlive80083",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Lucky 5",
      src: "",
      tableCode: "imlive80084",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "X-Roulette",
      src: "",
      tableCode: "imlive80085",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Hilo",
      src: "",
      tableCode: "imlive80086",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  {
    
      name: "Pushpa Rani",
      src: "",
      tableCode: "imlive80087",
      
      endpoint: "ezugi-games",
      "gameType": "Slots",
      provider: "vking",
      tpGameId: "1033",
      
  },
  ];

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Mac88 Games</span>{" "}
                    <span className="all">See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={PopularGames} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default MaccGames;
